<template>
    <div>
        <AlertDismiss ref="alertDismiss"></AlertDismiss>

        <b-pagination v-model="filter.page" :total-rows="rows" :per-page="filter.pageSize"
            aria-controls="table-list-document" class="m-2" pills>
        </b-pagination>
    </div>
</template>
<script>
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'

export default {
    name: 'StatementNotificationAssignmentPagination',

    data() {
        return {
            filter: {
                page: 1,
                pageSize: InitPageSize.SendStatement
            },

            rows: 0
        }
    },

    async mounted() {
        await this.getCount();

        //emitimos el evento para inicializar los valores de la tabla usuarios
        await this.paginationFilter();
    },

    components: {
        AlertDismiss
    },

    methods:{
        ...mapActions(["countFamilyStatementTemplateNotifications"]),

        paginationFilter() {
            this.$eventBus.$emit(EventNames.PaginationFilterFamilyAssignmentNotifications, this.filter);
        },

        async getCount() {
            const result = await this.countFamilyStatementTemplateNotifications();
            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }

            this.rows = result.data;
        }
    },

    watch: {
        //cada ves que se haga un click al paginador entonces emite el evento
        async "filter.page"() {
            this.paginationFilter();
        },
    }
}
</script>
<style>

</style>